import { ApiError } from './api-error';

/**
 * Envelope que usa TODO el BFF: `{ ok, data, error, correlationId }`.
 * (En el contrato generado todos los campos son opcionales; aquí lo modelamos una sola vez.)
 */
export interface ApiEnvelope<T> {
  ok?: boolean;
  data?: T | null;
  error?: { code?: string | null; message?: string | null; details?: unknown } | null;
  correlationId?: string | null;
}

/** Devuelve `data` o lanza `ApiError`. Cubre el caso "200 con ok:false" que el BFF puede devolver. */
export const unwrap = <T>(envelope: ApiEnvelope<T> | null | undefined, status = 200): T => {
  if (!envelope || envelope.ok === false) {
    throw new ApiError(
      status,
      envelope?.error?.code ?? 'unexpected_response',
      envelope?.error?.message ?? 'Respuesta inesperada del servidor',
      envelope?.error?.details,
      envelope?.correlationId ?? undefined,
    );
  }
  return envelope.data as T;
};
